import { takeLatest, all, put, select } from 'typed-redux-saga';
import { getApiParams } from 'api';
import { selectPageModelCategoryId, selectPageModelRegionId } from 'store/pageModel';
import { fetchCategoriesSuccess, fetchCategoriesRequest, fetchCategoriesFailed } from './slice';
import { fetchCategories } from './api';
import { TSLPData } from './types';

export function* getCategories() {
	try {
		const regionCode = yield* select(selectPageModelRegionId);
		const categoryId = yield* select(selectPageModelCategoryId);

		const { url, config } = yield getApiParams(
			'/services-platform/v0/slp/online-offers-by-category-id'
		);

		const data: TSLPData = yield fetchCategories(url, { regionCode, categoryId }, config);

		yield put(
			fetchCategoriesSuccess({
				data,
			})
		);
	} catch (error) {
		yield put(
			fetchCategoriesFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* servicesListingRootSaga() {
	return yield all([takeLatest(fetchCategoriesRequest.type, () => getCategories())]);
}
